import { TicketSalePageEvent } from 'app/pages/TicketSalePage/slice/types';
import { DateTime } from 'luxon';
import React from 'react';
import { SelectedBundle } from 'types/SelectedItem';
import { getAddons, getTicketTypes } from 'utils/bundles';
import { dateFormatForCalendar } from 'utils/calendar';
import { formatMoney } from 'utils/formatMoney';
import { EVENT_TYPE_WITH_CALENDAR } from 'utils/static/constants';
import { buildPriceToShow, getTotalOfItem } from 'utils/tickets';
import BundledAddonsListInsideOrderSummary from '../TicketSalePageTotal/BundledAddonsListInsideOrderSummary';

interface CartBundleProps {
  bundle: SelectedBundle;
  event: TicketSalePageEvent;
}

const CartBundle: React.FC<CartBundleProps> = ({
  bundle: selectedBundle,
  event,
}) => {
  const { id, name, quantity, price, date } = selectedBundle;
  const { type, tickets, ticketTypeBundles, currency } = event;

  const bundle = ticketTypeBundles!.find(bundle => bundle.id === id);
  const ticketTypes = getTicketTypes(bundle!.items, tickets);
  const bundledAddons = getAddons(ticketTypes, true);

  return (
    <div className="py-[8px] border-b border-neutral-40">
      <div className="flex gap-2 justify-between">
        <p className="p2-regular">
          {quantity}
          {' x '}
          {name}{' '}
          {date && type === EVENT_TYPE_WITH_CALENDAR ? (
            <span className="p4-regular text-neutral-800">
              (
              {DateTime.fromFormat(date, dateFormatForCalendar).toFormat(
                'cccc, LLLL d',
              )}
              )
            </span>
          ) : null}
        </p>
        <p className="p2-regular">
          {buildPriceToShow(
            getTotalOfItem(price, quantity),
            currency,
            formatMoney(0, currency),
          )}
        </p>
      </div>
      {bundledAddons.length > 0 ? (
        <BundledAddonsListInsideOrderSummary
          addons={bundledAddons}
          ticketQuantity={quantity}
        />
      ) : null}
    </div>
  );
};

export default CartBundle;

export const getCartBundleKey = (bundle: SelectedBundle) => {
  if (bundle.date) {
    return `${bundle.id}-${bundle.date}`;
  }
  return bundle.id;
};
